var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',{directives:[{name:"rw",rawName:"v-rw"}],staticStyle:{"width":"74px"},attrs:{"type":"error","custom-icon":_vm.value ? 'fas fa-lock' : 'fa fa-lock-open',"text":_vm.value ? 'unlock' : 'lock',"ghost":""},on:{"on-click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }